import dayjs from 'dayjs';

/**
 * The ISO calendar week of a date, as "KW 37".
 *
 * Purchasing agrees delivery dates in calendar weeks — the supplier's
 * confirmation says "Anlieferung in der Woche 37", not a day — so the mask has
 * to state the week next to the date instead of leaving people to count it
 * (#2185). Returns undefined for an empty or unparsable value, so a field with
 * no date simply shows no hint.
 *
 * `dayjs/plugin/isoWeek` is registered globally in the app entry point.
 */
export const formatCalendarWeek = (value?: string | Date | null): string | undefined => {
    if (!value) {
        return undefined;
    }

    const date = dayjs(value);

    return date.isValid() ? `KW ${date.isoWeek()}` : undefined;
};
